var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonChristmasWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1954px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil2 {fill:#CC9933}\n    .fil0 {fill:white}\n    .fil1 {fill:#CC9933;fill-rule:nonzero}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,9 372,9 372,1944 192,1767 9,1944 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M226 411l12 12c-9,5 -13,13 -13,22 0,7 2,13 8,17 5,5 12,9 21,11l77 15c1,-3 1,-5 1,-6 0,-9 -3,-16 -9,-22 -7,-6 -15,-9 -24,-9l-8 -16c15,1 27,7 35,18 9,11 13,26 13,44l0 7c-28,10 -57,17 -86,22l86 53 2 17 -26 -6 -66 -13c-6,-1 -11,-2 -15,-2 -4,0 -7,3 -7,9 0,3 1,7 1,12l-5 -1 -8 -41 106 21 -89 -55 -2 -8 3 0c21,0 47,-6 79,-16l-34 -7c-40,-8 -61,-25 -61,-53 0,-9 3,-18 9,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M238 669l-6 -1c-11,-16 -17,-30 -17,-41 0,-7 2,-13 7,-17 5,-5 12,-7 20,-7 14,0 27,5 40,16 12,11 19,23 19,35 0,5 -2,8 -5,11 -3,3 -7,4 -12,4 -9,0 -18,-5 -25,-15 -7,-9 -10,-21 -10,-35l-3 0c-15,0 -22,5 -22,16 0,9 4,21 14,34zm16 -50c1,12 3,20 8,27 5,6 12,9 19,9 8,0 12,-3 12,-8 0,-6 -4,-12 -12,-18 -8,-5 -17,-9 -27,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M217 685l24 6 37 7c3,1 6,1 9,1 4,0 7,-1 7,-4 0,-6 -6,-13 -17,-23l6 1c13,12 19,22 19,30 0,8 -4,11 -12,11 -4,0 -8,0 -13,-1l-18 -4 0 1c13,6 23,13 31,21 8,9 12,16 12,23 0,3 -1,7 -2,9l-14 -10c2,-3 3,-5 3,-7 0,-10 -14,-23 -43,-39l-28 -6 -1 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M219 771l23 5 37 7c4,1 7,2 10,2 4,0 6,-2 6,-5 0,-5 -6,-13 -17,-23l7 2c12,11 19,21 19,30 0,7 -4,11 -13,11 -3,0 -8,-1 -12,-2l-18 -3 0 1c12,6 23,13 31,21 8,8 12,16 12,22 0,4 -1,7 -3,10l-13 -10c2,-3 3,-6 3,-8 0,-10 -15,-23 -44,-39l-27 -5 -1 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M172 849l10 10c-2,5 -4,11 -4,16 0,7 3,13 8,17 4,3 14,7 27,10l48 12 0 -1c-12,-6 -22,-12 -30,-18 -7,-6 -11,-11 -11,-15 0,-3 2,-6 6,-8 4,-2 11,-3 22,-5l29 -3c11,-2 16,-4 16,-7 0,-3 -4,-8 -13,-15l8 1c10,8 16,16 16,23 0,4 -2,7 -6,8 -4,2 -11,4 -23,5l-25 3c-9,1 -13,3 -13,6 0,3 4,8 13,13 1,1 11,7 28,17l24 6 1 16 -24 -7 -53 -13c-19,-5 -32,-12 -42,-21 -10,-10 -14,-22 -14,-36 0,-6 0,-10 2,-14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M131 1420c2,-6 4,-12 4,-18 0,-9 -6,-16 -17,-21 -13,-7 -25,-10 -35,-10 -8,0 -12,2 -12,7 0,4 4,10 13,18 9,8 19,15 30,20l17 4zm-29 -6l0 -1c-13,-6 -22,-13 -30,-20 -8,-8 -12,-15 -12,-22 0,-10 7,-15 20,-15 14,0 27,6 41,17 14,11 21,26 21,42 0,7 0,15 -1,22l-21 -5 -36 -7c-6,-1 -10,-2 -11,-2 -3,0 -5,2 -5,4 0,5 6,12 16,22l-7 -1c-11,-11 -17,-20 -17,-29 0,-7 4,-10 11,-10 3,0 7,0 13,1l18 4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M61 1210l23 5 35 7c6,1 10,2 11,2 3,0 5,-2 5,-4 0,-5 -6,-12 -16,-22l7 1c11,11 17,20 17,29 0,7 -4,10 -11,10 -3,0 -7,0 -13,-1l-17 -4 0 1c12,6 22,13 29,20 8,8 12,14 12,21 0,3 -2,6 -4,8 -3,2 -6,3 -10,3 -3,0 -6,0 -10,-1l-17 -4 0 1c12,6 21,12 29,19 8,8 12,14 12,20 0,9 -5,13 -14,13 -3,0 -6,0 -10,-1l-35 -7c-6,-1 -9,-1 -11,-1 -3,0 -5,1 -5,4 0,5 6,12 16,21l-7 -1c-11,-10 -17,-20 -17,-28 0,-8 4,-11 11,-11 3,0 7,1 13,2l35 7c3,0 5,1 7,1 4,0 6,-2 6,-5 0,-8 -15,-20 -44,-36l-26 -6 -1 -14 58 12c3,0 5,0 7,0 4,0 6,-1 6,-4 0,-4 -4,-9 -13,-16 -8,-7 -19,-14 -31,-21l-26 -5 -1 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M136 1156l0 -17 5 5 0 13 21 4 3 15 -24 -5 0 27 -6 -6c0,-6 1,-11 1,-16l0 -6 -50 -10c-5,-1 -9,-1 -11,-1 -4,0 -6,1 -6,5 0,5 4,12 12,21l-7 -1c-9,-10 -14,-19 -14,-27 0,-9 5,-13 14,-13 3,0 8,1 13,2l49 10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 1061l10 9c-5,6 -7,13 -7,19 0,4 1,8 3,11 2,2 4,4 7,4 4,0 9,-3 15,-9l7 -6c7,-7 13,-10 17,-10 7,0 13,3 18,10 5,6 8,13 8,21 0,4 -1,9 -3,15l-16 -3 0 -5 1 0c1,0 1,0 2,0 6,0 9,-4 9,-12 0,-10 -3,-14 -11,-14 -4,0 -9,2 -15,8l-7 6c-7,6 -13,10 -18,10 -6,0 -12,-4 -17,-11 -5,-7 -8,-14 -8,-23 0,-6 2,-13 5,-20z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "155,1037 165,1042 179,1063 165,1056 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M84 1064l-7 -1c-11,-11 -17,-20 -17,-29 0,-7 4,-10 11,-10 3,0 7,0 13,1l25 5c7,2 12,2 14,2 4,0 6,-1 6,-4 0,-2 -1,-6 -2,-12l4 1 12 35 -24 -5 -35 -7c-6,-1 -9,-2 -11,-2 -3,0 -5,2 -5,4 0,5 6,12 16,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M61 936l23 6 35 7c4,0 7,1 9,1 4,0 7,-2 7,-5 0,-5 -6,-12 -17,-22l7 2c12,11 18,21 18,29 0,7 -4,10 -12,10 -4,0 -8,0 -12,-1l-17 -3 0 0c12,6 21,13 29,21 8,8 12,15 12,22 0,3 -1,6 -3,9l-13 -10c2,-3 3,-5 3,-7 0,-10 -14,-22 -41,-38l-27 -5 -1 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M61 830l23 5c33,7 59,13 92,26 3,1 7,3 10,4 3,1 11,5 13,3 1,-1 2,-2 3,-2 0,1 0,1 0,2 1,3 2,6 1,7 -2,2 -6,2 -12,1 -5,-1 -13,-3 -23,-6 -20,-8 -45,-13 -66,-18l0 2c12,6 22,13 29,21 8,7 12,14 12,21 0,8 -5,12 -14,12 -2,0 -6,-1 -10,-1l-35 -7c-6,-2 -9,-2 -11,-2 -3,0 -5,1 -5,4 0,5 6,12 16,22l-7 -1c-11,-11 -17,-21 -17,-29 0,-7 4,-11 11,-11 3,0 7,1 13,2l35 7c3,1 5,1 7,1 4,0 6,-1 6,-4 0,-9 -15,-22 -44,-39l-26 -5 -1 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M73 820c-8,-19 -12,-36 -12,-51 0,-15 4,-27 13,-36 9,-8 21,-12 37,-12 25,0 46,8 64,24 17,17 26,36 26,60 0,13 -2,26 -5,38l-25 -7 0 -6c3,0 5,1 7,1 5,0 9,-3 13,-9 3,-5 4,-13 4,-22 0,-14 -6,-26 -18,-36 -8,-7 -18,-12 -30,-17 -12,-4 -23,-6 -34,-6 -13,0 -23,3 -31,10 -7,7 -11,16 -11,28 0,13 3,27 10,42l-8 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 1447l10 9c-5,7 -7,13 -7,20 0,4 1,7 3,10 2,3 4,4 7,4 4,0 9,-3 15,-8l7 -7c7,-6 13,-9 17,-9 7,0 13,3 18,9 5,6 8,13 8,21 0,5 -1,10 -3,15l-16 -3 0 -5 1 1c1,0 1,0 2,0 6,0 9,-4 9,-13 0,-9 -3,-14 -11,-14 -4,0 -9,3 -15,8l-7 6c-7,7 -13,10 -18,10 -6,0 -12,-3 -17,-10 -5,-7 -8,-15 -8,-24 0,-6 2,-13 5,-20z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    transform: "matrix(1.17063 0.529041 -0.529041 1.17063 178.492 1523.36)",
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    transform: "matrix(1.17063 0.529041 -0.529041 1.17063 190.826 1590.59)",
    r: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil2",
    transform: "matrix(1.17063 0.529041 -0.529041 1.17063 202.434 1552.24)",
    rx: 8,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M280 1487c4,2 7,5 11,8 10,-5 20,-9 30,-13 -6,12 -21,30 -13,41 3,4 6,8 9,11 -9,2 -19,2 -27,6 -15,8 -6,9 -10,26 -9,-9 -19,-13 -25,-2 -11,-8 -19,-3 -32,3 9,-24 16,-25 3,-45 27,2 24,0 20,-25 22,9 25,13 34,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M240 1672c4,-2 8,-3 12,-5 8,7 17,15 25,22 -2,-14 -11,-36 0,-44 4,-3 8,-5 12,-8 -8,-4 -18,-7 -24,-13 -12,-12 -5,-10 -3,-28 -11,6 -21,9 -24,-3 -13,4 -18,-6 -29,-15 2,25 8,29 -10,44 26,6 23,7 12,30 23,-2 27,-6 29,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M87 1584c0,4 1,8 2,12 -9,7 -17,14 -26,21 13,1 37,-4 43,9 2,4 4,8 6,12 5,-7 10,-16 17,-21 14,-9 13,-5 30,1 -4,-13 -4,-23 8,-23 -1,-13 6,-15 18,-24 -26,-3 -30,2 -42,-19 -11,25 -11,22 -31,7 -3,23 0,27 -25,25z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    transform: "matrix(1.23417 0.557758 -0.557758 1.23417 170.75 194.45)",
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    transform: "matrix(1.23417 0.557758 -0.557758 1.23417 183.754 265.328)",
    r: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil2",
    transform: "matrix(1.23417 0.557758 -0.557758 1.23417 195.992 224.893)",
    rx: 8,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M278 156c4,3 7,5 11,8 11,-4 21,-9 32,-14 -6,13 -22,33 -14,44 3,4 7,8 10,12 -10,1 -20,1 -29,6 -16,8 -6,10 -10,28 -10,-10 -20,-14 -26,-3 -12,-8 -20,-2 -34,4 9,-25 17,-27 3,-48 28,2 25,0 21,-27 24,10 26,15 36,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M235 351c5,-2 9,-3 13,-5 9,8 18,15 27,23 -3,-14 -11,-38 0,-46 4,-3 8,-6 12,-9 -9,-4 -18,-7 -25,-14 -13,-13 -5,-10 -3,-29 -12,7 -23,10 -25,-3 -14,4 -19,-6 -31,-16 2,26 8,30 -11,47 28,6 24,6 13,31 25,-2 28,-6 30,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M74 258c1,5 1,9 2,13 -9,8 -18,15 -27,22 14,1 39,-4 45,9 2,5 4,9 6,14 6,-8 11,-17 19,-23 15,-10 13,-5 31,1 -4,-13 -4,-24 9,-24 -1,-14 6,-16 18,-25 -26,-4 -31,2 -44,-20 -11,26 -11,23 -33,7 -2,25 1,29 -26,26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonChristmasWhite);
export default __webpack_public_path__ + "static/media/ribbon-christmas-white.49108a51dde8f399f33caf3eaa48362b.svg";
export { ForwardRef as ReactComponent };